import { render, staticRenderFns } from "./SugoParts.vue?vue&type=template&id=1cda72c8&scoped=true"
import script from "./SugoParts.vue?vue&type=script&lang=ts"
export * from "./SugoParts.vue?vue&type=script&lang=ts"
import style0 from "./SugoParts.vue?vue&type=style&index=0&id=1cda72c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cda72c8",
  null
  
)

export default component.exports